module.exports = __webpack_public_path__ + "assets/img/package-woman.4d5c85e4.jpg";